import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

const MoreMenuItem = React.forwardRef(
  ({ visible = true, onClick, children }, ref) => {
    if (!visible) {
      return null;
    }
    return (
      <MenuItem ref={ref} onClick={onClick}>
        {children}
      </MenuItem>
    );
  }
);

export default MoreMenuItem;
